// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import store from './store/store'//引入vuex
import http from './http'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
// import '../static/my-theme/index.less';

import '../static/css/style.css';
import './assets/css/font-awesome.css'
import '../static/my-theme/index.css';
import '../static/my-theme/index.less';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import '../static/UEditor/ueditor.config'
import '../static/UEditor/ueditor.all.min.js'
import '../static/UEditor/lang/zh-cn/zh-cn.js'
import '../static/UEditor/ueditor.parse.min.js'

import axios from 'axios'
Vue.prototype.$axios = axios;


import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import './../static/css/index.css'

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
Vue.use(Vuex)
Vue.use(ViewUI);
axios.interceptors.response.use(function(res){
    if(res.data.code==115){
        router.push({
            path:'/login'
        });
        return false;
    }
    return res;
})
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization');
    }
    return config;
  },
  error => {
    return Promise.reject(error);
})

// import QRCode from 'qrcodejs2'
/**
 * 二维码生成方法
 * 已注入所有Vue实例，
 * template模板里调用 $QRCodeSC(src)
 * 组件方法里调用 this.$QRCodeSC(src)
 */
// const QRCodeSC = (url) => {
//   let qrcode = new QRCode('qrcode', { // qrcode  html为标签id
//     width: 100, // 长度
//     height: 100, // 宽度
//     text: url, // 内容
//     render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas)
//     // background: '#f0f'
//     // foreground: '#ff0'
//   })
//   return qrcode
// }
//Vue.prototype.$QRCodeSC = QRCodeSC


axios.defaults.baseURL = strUrl;


Vue.directive('drag',{
    inserted:function(el,binding){
        el.onmousedown=function(e){
            e.stopPropagation();
            let x = e.clientX - el.offsetLeft;
            let y = e.clientY - el.offsetTop;
            // let disx = e.pageX - el.offsetLeft;
            // let disy = e.pageY - el.offsetTop;
            document.onmousemove = function (e){
                e.preventDefault();
                let left = e.clientX - x;
                let top = e.clientY - y;
                this.positionX = left;
                this.positionY = top;
                //console.log(document.documentElement.clientHeight,odiv.offsetHeight)
                // 把拖拽元素 放到 当前的位置
                if (left <= 0) {
                    left = 0;
                } else if (left >= document.documentElement.clientWidth - el.offsetWidth){
                    //document.documentElement.clientWidth 屏幕的可视宽度
                    left = document.documentElement.clientWidth - el.offsetWidth;
                }
                
                if (top <= 0) {
                    top = 0;
                } else if (top >= document.documentElement.clientHeight - el.offsetHeight){
                    // document.documentElement.clientHeight 屏幕的可视高度
                    top = document.documentElement.clientHeight - el.offsetHeight
                    
                }
                // el.style.left = e.pageX - disx+'px';
                // el.style.top = e.pageY - disy+'px';
                el.style.left = left + "px";
                el.style.top = top + "px";
            }
            document.onmouseup = function(){
                document.onmousemove = document.onmouseup = null;
                //binding 传参，可忽略
                if(binding && binding.value){
                    binding.value.clientX = parseInt(el.style.left);
                    binding.value.clientY = parseInt(el.style.top);
                }
            }
        }
    },
});

Vue.prototype.$AppName = AppName;


axios.defaults.withCredentials = false;
Vue.config.productionTip = false;

// import './fillter.js'

/* eslint-disable no-new */
new Vue({
    el: '#app',
	store,
  	router,
    http,
  	components: { App },
  	template: '<App/>',
    
})



// WEBPACK FOOTER //
// ./src/main.js